import React,{  useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import { ABMEmpresas } from "./ABMEmpresas";
import { useDispatch } from "react-redux";
import { empresaLimpiar } from "../../actions/empresas/empresas";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function NuevaEmpresaModal({ abrirModal, setAbrirModal,item }) {
  const classes = useStyles();
  const dispatch = useDispatch();
 

  const handleClose = () => {
    dispatch(empresaLimpiar());
    setAbrirModal(false);
  };

  const childRef = useRef();

  return (
    <div>
      <Dialog
        fullScreen
        open={abrirModal}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              Alta Nueva Empresa
            </Typography>
            <Button
              autoFocus
              color="inherit"
              onClick={(e) => {
                childRef.current.guardarEmpresa(e);
                //handleClose();
              }}
            >
              Guardar
            </Button>
          </Toolbar>
        </AppBar>
        {/* <List>
          <ListItem button>
            <ListItemText primary="Phone ringtone" secondary="Titania" />
          </ListItem>
          <Divider />
          <ListItem button>
            <ListItemText primary="Default notification ringtone" secondary="Tethys" />
          </ListItem>
        </List> */}
    
         <ABMEmpresas ref={childRef} cerrarPop={handleClose} empresaAfiliado={item}/>
      </Dialog>
    </div>
  );
}
